import script from "./CompatibilitiesCheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CompatibilitiesCheckBox.vue?vue&type=script&setup=true&lang=js"

import "./CompatibilitiesCheckBox.vue?vue&type=style&index=0&id=15eb2993&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15eb2993"]])

export default __exports__